import { ReactComponent as ThinnectLogo } from './../assets/icons/Thinnect_white.svg';
import footerMobilePicture from '../assets/img/footer_login_mobile.png';
import footerMediumPicture from '../assets/img/footer_login_medium.png';
import footerLargePicture from '../assets/img/footer_login_large.png';
import { useAppSelector } from '../redux/hooks';

const MainFooter = () => {
	const isLoggedIn = useAppSelector((state) => state.authentication.loggedIn);

	return isLoggedIn ? (
		<footer className="mt-auto">
			<small className="my-5 d-flex flex-column align-items-center">
				<a
					className="d-flex flex-column flex-sm-row align-items-center text-decoration-none text-reset focus-ring"
					target="_blank"
					rel="noopener noreferrer"
					href="https://thinnect.com"
				>
					<span className="me-0 me-sm-2">Solution provided by:</span>
					<ThinnectLogo style={{ width: '125px', fill: 'currentColor' }} />
				</a>
				{process.env.REACT_APP_VERSION ? (
					<span className="mt-1">Version: {process.env.REACT_APP_VERSION}</span>
				) : undefined}
			</small>
		</footer>
	) : (
		<footer>
			<picture>
				<source media="(min-width:1200px)" srcSet={footerMediumPicture} />
				<source media="(min-width:576px)" srcSet={footerLargePicture} />
				<img
					src={footerMobilePicture}
					alt="Mobile login footer"
					className="w-100 h-auto opacity-75"
				/>
			</picture>
		</footer>
	);
};

export default MainFooter;
